import {
  createSlice,
  createEntityAdapter,
  createSelector,
  isAnyOf,
} from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import { RootState } from "admin/store";
import { fetchHotel, fetchHotelIfNeeded } from "./hotelSlice";
import { HotelRoomPlan } from "admin/types/hotelRoomPlan";
import {
  hotelRoomEntitiesSelector,
  postHotelRoom,
  putHotelRoom,
} from "./hotelRoom/hotelRoomSlice";
import {
  hotelPlanEntitiesSelector,
  postHotelPlan,
  putHotelPlan,
} from "./hotelPlan/hotelPlanSlice";
import { HotelPlanStatuses } from "admin/constants/hotelPlanStatuses";

const key = "hotelRoomPlan";

const adapter = createEntityAdapter<HotelRoomPlan>();

const initialState = adapter.getInitialState({});

/** slice **/
export const hotelRoomPlanSlice = createSlice({
  name: key,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(HYDRATE, (state, action: any) => {
        return { ...state, ...action.payload.hotelRoomPlan };
      })
      .addCase(postHotelRoom.fulfilled, (state, action) => {
        action.payload.entities.hotelRoomPlans &&
          adapter.setAll(state, action.payload.entities.hotelRoomPlans);
      })
      .addCase(putHotelRoom.fulfilled, (state, action) => {
        action.payload.entities.hotelRoomPlans &&
          adapter.setAll(state, action.payload.entities.hotelRoomPlans);
      })
      .addCase(postHotelPlan.fulfilled, (state, action) => {
        action.payload.entities.hotelRoomPlans &&
          adapter.setAll(state, action.payload.entities.hotelRoomPlans);
      })
      .addCase(putHotelPlan.fulfilled, (state, action) => {
        action.payload.entities.hotelRoomPlans &&
          adapter.setAll(state, action.payload.entities.hotelRoomPlans);
      })
      .addMatcher(
        isAnyOf(fetchHotel.fulfilled, fetchHotelIfNeeded.fulfilled),
        (state, action) => {
          adapter.setAll(state, action.payload.entities.hotelRoomPlans ?? []);
        },
      );
  },
});

/** selector **/
export const {
  selectById: hotelRoomPlanByIdSelector,
  selectIds: hotelRoomPlanIdsSelector,
  selectEntities: hotelRoomPlanEntitiesSelector,
  selectAll: hotelRoomPlansSelector,
  selectTotal: totalHotelRoomPlansSelector,
} = adapter.getSelectors((state: RootState) => state.hotelRoomPlan);

// const stateSelector = (state: RootState) => state[key];

export const hotelPlansByRoomSelector = createSelector(
  [
    hotelRoomPlanEntitiesSelector,
    hotelPlanEntitiesSelector,
    (state, roomId: number) => roomId,
  ],
  (entities, planEntities, roomId) => {
    const hotelPlanIds = Object.keys(entities)
      .filter(
        (id) =>
          entities[id].hotelRoomId === roomId &&
          planEntities[entities[id].hotelPlanId].status !==
            HotelPlanStatuses.deleted,
      )
      .map((id) => entities[id].hotelPlanId);
    return hotelPlanIds.map((id) => planEntities[id]);
  },
);

export const hotelRoomsByPlanSelector = createSelector(
  [
    hotelRoomPlanEntitiesSelector,
    hotelRoomEntitiesSelector,
    (state, planId: number) => planId,
  ],
  (entities, roomEntities, planId) => {
    const hotelRoomIds = Object.keys(entities)
      .filter((id) => entities[id].hotelPlanId === planId)
      .map((id) => entities[id].hotelRoomId);
    return hotelRoomIds.map((id) => roomEntities[id]);
  },
);
